import { RouteStopTemplateService } from './routeStopTemplate-service';

let routeStopTemplateService = new RouteStopTemplateService();

export { routeStopTemplateService }